import React from "react";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import Select from "react-select";
import Header from "../../components/Header";
import MyModal from "../../components/MyModal";
import Firebase from "../../firebasehelper";

import "./index.css";
import {
  SalesManagerOptions,
  Characters,
  SectorOptions,
} from "../../Constants/brand";

const stageOptions = [
  "All",
  "Introduction",
  "Explore",
  "Decision",
  "Commercials",
  "Full Roll Out",
  "Test Roll Out",
];

class Umbrella extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      brands: [],
      umbrellaAdmins: [],
      stageFilter: {
        value: "All",
        label: "All",
      },
      salesManager: {
        value: "all",
        label: "All",
      },
      brandNameFilter: {
        value: "all",
        label: "All",
      },
      sectorFilter: {
        value: "all",
        label: "All",
      },
    };
  }

  componentDidMount() {
    const { role } = this.props.location.state;
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      if (role !== 0) this.props.history.push("/");
    }
    Firebase.getAllBrands((res) => {
      let brands = res
        .map((item, index) => {
          let new_item = item;
          new_item.id = index;
          return new_item;
        })
        .filter((item) => item && !item.deactive && item.umbrella);

      this.setState({ brands });
    });
    Firebase.getAllAgencies((res) => {
      this.setState({ umbrellaAdmins: res.filter((obj) => obj.role === 10) });
    });
  }

  filterBrands = () => {
    const { brands, stageFilter, salesManager, brandNameFilter, sectorFilter } =
      this.state;
    console.log("brands: ", brands);
    let filtered = [];
    if (stageFilter.value === "All") {
      filtered = [...brands];
    } else {
      filtered = brands.filter((item) => item.salesStage === stageFilter.value);
    }

    if (salesManager.value !== "all") {
      filtered = filtered.filter(
        (item) => item.salesManager === salesManager.value
      );
    }

    if (brandNameFilter.value !== "all") {
      filtered = filtered.filter((item) =>
        item.name.toLowerCase().startsWith(brandNameFilter.value.toLowerCase())
      );
    }
    if (sectorFilter.value !== "all") {
      filtered = filtered.filter((item) => item.sector === sectorFilter.value);
    }
    return filtered;
  };

  addBrand = (
    brandName,
    brandUrl,
    logo_img,
    icon_img,
    hexcode,
    territory,
    umbrella
  ) => {
    Firebase.addFiletoBrand(
      brandName,
      brandUrl,
      logo_img,
      icon_img,
      hexcode,
      territory,
      umbrella,
      (res) => {
        if (res !== "error") {
          Firebase.createDefaultBrandAdmin(res, brandName);
        }
      }
    );
  };

  goToBrandAdmin = (brand) => () => {
    this.props.history.push("/brand", {
      username: this.props.location.state.username,
      role: this.props.location.state.role,
      brand: brand.id,
    });
  };

  onFilterChanged = (filter) => {
    this.setState({
      filter,
    });
  };

  renderFilter = () => (
    <div className="filter_tab">
      <button className="btn" onClick={() => this.onFilterChanged("all")}>
        View All
      </button>
      <button
        className="btn"
        onClick={() => this.onFilterChanged("Introduction")}
      >
        Introduction
      </button>
      <button className="btn" onClick={() => this.onFilterChanged("Explore")}>
        Explore
      </button>
      <button className="btn" onClick={() => this.onFilterChanged("Decision")}>
        Decision
      </button>
      <button
        className="btn"
        onClick={() => this.onFilterChanged("Commercials")}
      >
        Commercials
      </button>
    </div>
  );

  showBrands = () => {
    const { umbrellaAdmins } = this.state;

    const filteredBrands = this.filterBrands();
    filteredBrands.sort(function (a, b) {
      var textA = a.name.toUpperCase();
      var textB = b.name.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    let username = this.props.location.state.username;
    let role = this.props.location.state.role;

    return filteredBrands.map((item) => {
      const logo = item.logo;
      const brand = item.id;

      const umbrellaAdmin = umbrellaAdmins.filter(
        (obj) => obj.brand === item.id
      )[0];
      return (
        <div className="brand-item-container" key={item.id}>
          <Link
            to={{
              pathname: "/brand",
              state: {
                brand: brand,
                username: username,
                role: role,
              },
            }}
            className="block block-rounded block-link-pop text-center"
          >
            <div className="logo-container">
              <img src={logo} alt="logo" />
            </div>
          </Link>
          <div className="row-value big">Umbrella Brand</div>
          <div className="row-value">{item.salesManager}</div>
          <div className="row-value">
            {umbrellaAdmin && umbrellaAdmin.username}
          </div>
          <div className="row-value big">
            Potential Size{" "}
            {(item.potentialSize || "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </div>
          <div className="row-value">
            <button className="btn" onClick={this.goToBrandAdmin(item)}>
              Edit
            </button>
          </div>
        </div>
      );
    });
  };

  handleSalesManagerChanged = (value) => {
    this.setState({
      salesManager: value,
    });
  };

  handleBrandNameFilterChanged = (value) => {
    this.setState({
      brandNameFilter: value,
    });
  };

  handleSectorFilterChanged = (value) => {
    this.setState({
      sectorFilter: value,
    });
  };

  handleStageFilterChanged = (value) => {
    this.setState({
      stageFilter: value,
    });
  };

  render() {
    const { brands, stageFilter, salesManager, brandNameFilter, sectorFilter } =
      this.state;
    if (!this.props.location.state) return <Redirect to="/" />;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;
    console.log("role in channel", role);
    return (
      <div id="page-container">
        <Header username={username} role={role} />
        <main id="main-container" className="channel-container">
          <div className="content">
            {brands.length ? (
              <React.Fragment>
                <div className="add-brand-filter-container">
                  <div className="sales-filter-group">
                    <p className="group-label">Sales Team</p>
                    <div className="input-container">
                      <Select
                        value={salesManager}
                        onChange={this.handleSalesManagerChanged}
                        options={[
                          {
                            value: "all",
                            label: "All",
                          },
                          ...SalesManagerOptions,
                        ]}
                      />
                    </div>
                  </div>
                  <div className="sales-filter-group name-filter">
                    <p className="group-label">Brand Name</p>
                    <div className="input-container">
                      <Select
                        value={brandNameFilter}
                        onChange={this.handleBrandNameFilterChanged}
                        options={[
                          {
                            value: "all",
                            label: "All",
                          },
                          ...Characters.map((item) => ({
                            value: item,
                            label: item,
                          })),
                        ]}
                      />
                    </div>
                  </div>
                  <div className="sales-filter-group">
                    <p className="group-label">Sector Filter</p>
                    <div className="input-container">
                      <Select
                        value={sectorFilter}
                        onChange={this.handleSectorFilterChanged}
                        options={[
                          {
                            value: "all",
                            label: "All",
                          },
                          ...SectorOptions,
                        ]}
                      />
                    </div>
                  </div>
                  <div className="sales-filter-group">
                    <p className="group-label">Stage</p>
                    <div className="input-container">
                      <Select
                        value={stageFilter}
                        onChange={this.handleStageFilterChanged}
                        options={stageOptions.map((option) => ({
                          value: option,
                          label: option,
                        }))}
                      />
                    </div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary post add-new-brand"
                    data-toggle="modal"
                    data-target="#add_brand"
                  >
                    Add a new brand
                  </button>
                </div>
                <div className="brands-container">{this.showBrands()}</div>
              </React.Fragment>
            ) : (
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            )}
          </div>
          <MyModal
            addImage={this.addBrand}
            brands={brands}
            isSuperAdmin={role === 0}
          />
        </main>
      </div>
    );
  }
}
export default Umbrella;



// WEBPACK FOOTER //
// ./src/screens/Umbrella/index.js